import React from 'react'
import styles from './section.module.scss'

const SectionHeader = (props) => {
	return(
		<div className={styles.title}>{props.title}</div>
	)
}

export default SectionHeader